import State from '../core/State';
import { SalesData } from '@kaizenplatform/intelligence-entity';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startFetchingSales = () =>
  produce((draft: Draft<State>) => {
    draft.sales.fetching = draft.sales.fetching + 1;
  });

export const setSales = (salesData: SalesData) =>
  produce((draft: Draft<State>) => {
    draft.sales.data = salesData;
  });

export const finishFetchingSales = () =>
  produce((draft: Draft<State>) => {
    draft.sales.fetching = draft.sales.fetching - 1;
  });

export const disposeSales = () =>
  produce((draft: Draft<State>) => {
    draft.sales.data = initialState.sales.data;
    draft.sales.fetching = initialState.sales.fetching;
  });
